import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Identity } from "@aptsi-types";
import { environment } from "@env";

import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { ErrorHandlingService } from "src/app/features/ada-access/shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from "../../secure-blockchain-api-endpoints";


interface GetIdentityResponse {
  identityview: Identity[];
}

@Injectable({
  providedIn: 'root'
})
export class IdentityService {

  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient
  ) { }

  getIdentities(currentPage: number) {
    return this.http.post<any>(
      `${this.baseUrl}${API_ENDPOINTS.IDENTITY.READ}`, {currentPage}
    )
  }

  getIdentityById(id: string) {
    return this.http.get<any>(
      `${this.baseUrl}${API_ENDPOINTS.IDENTITY.GET}/${id}`
    )
  }

  searchIdentities(currentPage:number, searchText:String, filterByHeader: String) {
    return this.http.post(
      `${this.baseUrl}${API_ENDPOINTS.IDENTITY.SEARCH}`,
      { currentPage, searchText, filterByHeader }
    )
    
  }

  createIdentity(data: any) {
    return this.http.post(
      `${this.baseUrl}${API_ENDPOINTS.IDENTITY.CREATE}`, data
    )
  }

  updateIdentity(data: any) {
    return this.http.post(
      `${this.baseUrl}${API_ENDPOINTS.IDENTITY.UPDATE}`, data
    )
  }

  revokeIdentity(userId: string) {
    return this.http.post(
      `${this.baseUrl}${API_ENDPOINTS.IDENTITY.REVOKE}`,
      { userId }
    )
  }

  getMergedIdentities(page: number) {
    return this.http.post(
      `${this.baseUrl}${API_ENDPOINTS.IDENTITY.MERGED}?page=${page}`, {}
    )
  }
}